import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { QueryConfig } from '@/lib/react-query';
import type { Division } from '@/types/api';

export const getDivisions = (): Promise<{ divisions: Division[] }> => {
  return api.get(`/scoreboard/v1/divisions`);
};

export const getDivisionsQueryOptions = () => {
  return queryOptions({
    queryKey: ['divisions'],
    queryFn: () => getDivisions(),
  });
};

type UseTournamentQueryOptions = {
  queryConfig?: QueryConfig<typeof getDivisionsQueryOptions>;
};

export const useDivisions = ({
  queryConfig,
}: UseTournamentQueryOptions = {}) => {
  return useQuery({
    ...getDivisionsQueryOptions(),
    ...queryConfig,
  });
};
